export default __webpack_public_path__ + "static/media/WHT-Annual-Filing-Template.b600a12f.xlsx";